'use client';
import { getWeekendLeaguePrizes } from './prizes';
export function useWeekendLeaguePrizes() { return getWeekendLeaguePrizes(); }
